import { useQuery } from '@tanstack/react-query';
import { clientApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

export function useClients() {
  return useQuery({
    queryKey: queryKeys.organization.clients(),
    queryFn: ({ signal }) =>
      clientApiClient.getClients('', toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: {
      suppressErrorToast: true,
      errorContext: 'organization clients',
    },
  });
}
